import HttpClient from '@/common/boot/HttpClient'
import criarToast from '@/common/boot/ToastsHandler'

const listarRotas = async({ commit }) => {
    commit('BUSCANDO', true)

    await HttpClient.get('/app/rotas').then(response => {
            commit('INSERIR_LISTA_ROTAS', response.data.data)
            return response
        })
        .finally(() => {
            commit('BUSCANDO', false)
        })
}

const listarSubmodulos = async({ commit }) => {
    await HttpClient.get('/app/submodulos').then(response => {
        commit('LISTAR_SUBMODULOS', response.data.data);
        return response;
    });
}

const salvarRota = async({ commit }, payload) => {
    commit('BUSCANDO', true);
    await HttpClient.post('/app/rotas', payload).then(response => {
            commit('INSERIR_ROTA', response.data.data);
            return response;
        })
        .finally(() => {
            commit('BUSCANDO', false);
        });
}

const atualizarRota = async({ commit }, payload) => {
    commit('BUSCANDO', true);
    const payloadData = {
        id: payload.id,
        rota: payload.rota.trim(),
        descricao: payload.descricao.trim(),
        acl_submodulo_id: payload.acl_submodulo_id
    };

    await HttpClient.put(`/app/rotas/${payload.id}`, payloadData).then(response => {
            criarToast({
                tipo: 'success',
                mensagem: 'Rotas atualizada com sucesso!'
            })
            commit('ATUALIZAR_ROTA', payload);
            return response;
        })
        .finally(() => {
            commit('BUSCANDO', false);
        });
}

const excluirRota = async({ commit }, payload) => {
    commit('BUSCANDO', true);
    payload.forEach(rota => {
        HttpClient.delete(`/app/rotas/${rota.id}`).then(response => {
            commit('DELETAR_LISTA_ROTA', rota)
            return response;
        });
    })
    commit('BUSCANDO', false);
}


export {
    listarRotas,
    listarSubmodulos,
    salvarRota,
    atualizarRota,
    excluirRota
}